import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './index.css';

const TestableRouterLink = testable(QA_MALT, Link);
const TestableAnchor = testable(QA_MALT, 'a');

const TextLink = ({ href = ' ', to, className, children, ...other }) => {
  const LinkElement = to ? TestableRouterLink : TestableAnchor;
  return (
    <LinkElement
      href={href}
      to={to}
      className={classNames(styles.textlink, className)}
      {...other}
    >
      {children}
    </LinkElement>
  );
};

TextLink.displayName = 'TextLink';

TextLink.propTypes = {
  /** set the link destination
   *
   * Please note: If you use client-side navigation via
   * pushState browser history manipulation, a `:visited` state
   * might not be shown – [more info](https://developer.mozilla.org/en-US/docs/Web/API/History_API#Adding_and_modifying_history_entries)
   */
  href: PropTypes.string,
  /** set the link destination using the UI-Router */
  to: PropTypes.string,
  /** set a title as additional information */
  title: PropTypes.string,
  /** define a target, e.g. `_blank` */
  target: PropTypes.string,
  /** define the onClick function here */
  onClick: PropTypes.func,
  /** add a custom className to the component */
  className: PropTypes.string,
  /** render the link text or other content */
  children: PropTypes.node.isRequired,
  /** define a testid for the link */
  testId: PropTypes.string,
  /** define a rel for the link */
  rel: PropTypes.string,
  /** When `true`, clicking the link will replace the current entry in the history stack instead of adding a new one. Only relevant when `to` is set as well. */
  replace: PropTypes.bool,
};

export default TextLink;
